import { ESdChangeReason, IKuikaStyle, InvisibleStylePart, StyleState, Visibility } from "@kuika/kuika-cl-model";
import { Form } from "antd/es";
import { FormInstance } from "antd/es/form";
import React from "react";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../../shared/pure-sd";
import EffectsPresetsComponent from "./effects-presets/effects-presets-component";
import EffectsAnimationsComponent from "./styling-effects-animations-component";
import EffectsBasicComponent from "./styling-effects-basic-component";
import EffectsEntryAnimationComponent from "./styling-effects-entry-animation-component";
import EffectsFiltersComponent from "./styling-effects-filters-component";
import EffectsOutlineComponent from "./styling-effects-outline-component";
import EffectsTransformsComponent from "./styling-effects-transforms-component";
import EffectsTransitionsComponent from "./styling-effects-transitions-component";
import { styleSectionNeedsRender } from "./styling-window-helpers";

export interface IEffectsComponentProps {
  form: FormInstance<IKuikaStyle>;
  onRequestStateChange?: (state: StyleState) => void;
  onPrepareStatePresetCommit?: () => void;
}

interface IEffectsComponentState {
  // Reserved for Faz 3+ (tag picker, edit modal, default style backup) to keep
  // BorderComponent parity. Currently no internal state — child components own
  // their own state (color picker open/closed, etc.).
  placeholder: never[];
}

class EffectsComponent extends PureSdComponent<IEffectsComponentProps & IWithSDProps, IEffectsComponentState> {
  constructor(props: IEffectsComponentProps & IWithSDProps) {
    super(props);
    this.state = {
      placeholder: []
    };
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => styleSectionNeedsRender(changeReason);

  render(): React.ReactNode {
    const isEffectsVisible: Visibility = this.props.sd.getStylesVisibility(InvisibleStylePart.Effects);
    if (isEffectsVisible === Visibility.Hidden) {
      return null;
    }

    return (
      <div className="kuika-styling-panel__effects-form effects-section">
        <Form.Item name={["effects", "effectsId"]} noStyle shouldUpdate>
          <input type="hidden" />
        </Form.Item>
        <Form.Item name={["effects", "kuikaid"]} noStyle shouldUpdate>
          <input type="hidden" />
        </Form.Item>
        <Form.Item name={["effects", "mixBlendMode"]} noStyle shouldUpdate>
          <input type="hidden" />
        </Form.Item>
        <Form.Item name={["effects", "cursor"]} noStyle shouldUpdate>
          <input type="hidden" />
        </Form.Item>
        <Form.Item name={["effects", "pointerEvents"]} noStyle shouldUpdate>
          <input type="hidden" />
        </Form.Item>
        <Form.Item name={["effects", "transforms"]} noStyle shouldUpdate>
          <input type="hidden" />
        </Form.Item>
        <Form.Item name={["effects", "transitions"]} noStyle shouldUpdate>
          <input type="hidden" />
        </Form.Item>
        <Form.Item name={["effects", "filters"]} noStyle shouldUpdate>
          <input type="hidden" />
        </Form.Item>
        <Form.Item name={["effects", "backdropFilters"]} noStyle shouldUpdate>
          <input type="hidden" />
        </Form.Item>
        {/* Entry/mount animation (reveal presets). Hidden field so the preset-set
            value survives form round-trips and reaches the generator. */}
        <Form.Item name={["effects", "entryAnimation"]} noStyle shouldUpdate>
          <input type="hidden" />
        </Form.Item>
        {/* Looping animations (preset or custom keyframes). Hidden field so the
            array survives form round-trips and reaches the generator. */}
        <Form.Item name={["effects", "animations"]} noStyle shouldUpdate>
          <input type="hidden" />
        </Form.Item>
        <Form.Item name={["effects", "transformOriginX"]} noStyle shouldUpdate>
          <input type="hidden" />
        </Form.Item>
        <Form.Item name={["effects", "transformOriginY"]} noStyle shouldUpdate>
          <input type="hidden" />
        </Form.Item>
        <Form.Item name={["effects", "backfaceVisibility"]} noStyle shouldUpdate>
          <input type="hidden" />
        </Form.Item>
        <Form.Item name={["effects", "transformStyle"]} noStyle shouldUpdate>
          <input type="hidden" />
        </Form.Item>
        <Form.Item name={["effects", "perspective"]} noStyle shouldUpdate>
          <input type="hidden" />
        </Form.Item>
        <Form.Item name={["effects", "childrenPerspective"]} noStyle shouldUpdate>
          <input type="hidden" />
        </Form.Item>
        <Form.Item name={["effects", "childrenPerspectiveOriginX"]} noStyle shouldUpdate>
          <input type="hidden" />
        </Form.Item>
        <Form.Item name={["effects", "childrenPerspectiveOriginY"]} noStyle shouldUpdate>
          <input type="hidden" />
        </Form.Item>
        <EffectsPresetsComponent
          form={this.props.form}
          onRequestStateChange={this.props.onRequestStateChange}
          onPrepareStatePresetCommit={this.props.onPrepareStatePresetCommit}
        />
        <div className="effects-section__top-group">
          <EffectsBasicComponent form={this.props.form} slice="head" />
          <EffectsOutlineComponent form={this.props.form} />
          <EffectsBasicComponent form={this.props.form} slice="tail" />
        </div>
        <div className="effects-section__multi-group">
          <EffectsTransformsComponent form={this.props.form} />
          <EffectsTransitionsComponent form={this.props.form} />
          <EffectsEntryAnimationComponent form={this.props.form} />
          <EffectsAnimationsComponent form={this.props.form} />
          <EffectsFiltersComponent form={this.props.form} />
        </div>
      </div>
    );
  }
}

export default withSD<IEffectsComponentProps>(EffectsComponent);
